<div class="bg-primary p-4 text-white rounded-t flex justify-between items-center">
  <h2 class="text-lg font-semibold">Note History</h2>
</div>

<div class="bg-white p-4 rounded-b shadow flex flex-col h-[400px]">
  <!-- Notes List -->
  <div class="flex-1 overflow-y-auto mb-4 border-b border-gray-200">
    <div
      *ngFor="let note of (orderDetailsFromStore$ | async)?.notes || orderDetails?.notes; trackBy: trackByNoteId"
      class="py-3 border-b border-gray-100 last:border-b-0"
    >
      <div class="text-gray-800">{{ note.note }}</div>
      <div class="text-xs text-gray-500 mt-1">
        -{{ note.user.firstName }} {{ note.user.lastName }},
        {{ note.dateCreated | date: 'MM/dd/yyyy hh:mm a' }}
      </div>
    </div>
  </div>

  <!-- Add Note Form -->
  <form [formGroup]="noteForm" (ngSubmit)="onSaveNote()" class="flex flex-col gap-2">
    <mat-form-field appearance="fill" class="w-full">
      <mat-label>Add a note</mat-label>
      <input matInput formControlName="noteInput" autocomplete="off" />
    </mat-form-field>
    <button
      mat-flat-button
      color="warn"
      class="self-end flex items-center gap-2"
      type="submit"
      *ngIf="!viewDisable"
      [disabled]="
        noteForm.get('noteInput')?.invalid ||
        noteForm.get('noteInput')?.pristine ||
        (addNoteLoading$ | async)
      "
    >
      <mat-spinner *ngIf="addNoteLoading$ | async" diameter="20" class="!inline-block !w-5 !h-5" />
      <span *ngIf="(addNoteLoading$ | async) === false">SAVE NOTE</span>
      <span *ngIf="addNoteLoading$ | async">Saving...</span>
    </button>
  </form>
</div>
